import { defaultStore } from '@/library/firebase'

export const getUser = uid => {
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('users')
      .doc(uid)
      .get()
      .then(doc => {
        resolve(doc.data())
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}
